// extracted by mini-css-extract-plugin
module.exports = {"fontWeight":"bold","fontSize":"14","fontColor":"#002942","firstChartColor":"#68a62b","secondChartColor":"#002942"};